export default __webpack_public_path__ + "static/media/img-mario-run.6d02cd24.gif";